import { render } from "./Tabbar.vue?vue&type=template&id=e195cec6"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonnorth/VueCloud/cloud-market/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__